/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_typing_input_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Click here and start typing…`)
};

const es_typing_input_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Haz clic aquí y empieza a escribir…`)
};

const de_typing_input_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hier klicken und mit dem Tippen beginnen…`)
};

const nl_typing_input_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klik hier en begin met typen…`)
};

const fr_typing_input_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cliquez ici et commencez à taper…`)
};

const it_typing_input_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clicca qui e inizia a digitare…`)
};

const pt_br2_typing_input_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clique aqui e comece a digitar…`)
};

const pt_typing_input_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clique aqui e comece a escrever…`)
};

const ja_typing_input_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ここをクリックして入力を開始…`)
};

const zh_typing_input_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`点击此处开始输入…`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const typing_input_placeholder = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.typing_input_placeholder(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("typing_input_placeholder", locale)
	if (locale === "en") return en_typing_input_placeholder(inputs)
	if (locale === "es") return es_typing_input_placeholder(inputs)
	if (locale === "de") return de_typing_input_placeholder(inputs)
	if (locale === "nl") return nl_typing_input_placeholder(inputs)
	if (locale === "fr") return fr_typing_input_placeholder(inputs)
	if (locale === "it") return it_typing_input_placeholder(inputs)
	if (locale === "pt-BR") return pt_br2_typing_input_placeholder(inputs)
	if (locale === "pt") return pt_typing_input_placeholder(inputs)
	if (locale === "ja") return ja_typing_input_placeholder(inputs)
	return zh_typing_input_placeholder(inputs)
};